import React from "react";
import "./financial.less";
import InvitsFinancialTable from "./Compare Table/table";

const InvITsFinancial: React.FC = () => {
  const displayName = "cmp-compare-reits";

  return (
    <div className={displayName}>
      <section className={`${displayName}__hero-Banner`}>
        <div className={`${displayName}__hero-Text`}>
          <h1>
            Compare <span>InvITs Financial Metrics</span>
          </h1>
          <p>
            Whether you're just exploring or ready to commit, use our comparison
            tool to evaluate platforms side-by-side — and choose the one that
            fits your financial goals.
          </p>
        </div>
      </section>
      <InvitsFinancialTable />
    </div>
  );
};

export default InvITsFinancial;
